// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type LotSummaryMetaDataQueryVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
  internalUserId: Types.Scalars['ID']['input'];
}>;


export type LotSummaryMetaDataQuery = { __typename?: 'Query', development: { __typename?: 'Development', name: string, id: string, isSequenceSheetFollower: boolean, isTeamMember: boolean, market: { __typename?: 'Market', id: string }, cohorts?: Array<{ __typename?: 'Cohort', id: string, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, scopeMode: { __typename?: 'ScopeModeDetail', code: Types.ScopeMode } }
        | { __typename?: 'Region', id: string, scopeMode: { __typename?: 'ScopeModeDetail', code: Types.ScopeMode } }
        | { __typename?: 'Market', id: string, scopeMode: { __typename?: 'ScopeModeDetail', code: Types.ScopeMode } }
        | { __typename?: 'Community', id: string, scopeMode: { __typename?: 'ScopeModeDetail', code: Types.ScopeMode } }
        | { __typename?: 'Subdivision', id: string, scopeMode: { __typename?: 'ScopeModeDetail', code: Types.ScopeMode } }
        | { __typename?: 'Lot', id: string, scopeMode: { __typename?: 'ScopeModeDetail', code: Types.ScopeMode } }
        | { __typename?: 'Structure', id: string, scopeMode: { __typename?: 'ScopeModeDetail', code: Types.ScopeMode } }
        | { __typename?: 'Unit', id: string, scopeMode: { __typename?: 'ScopeModeDetail', code: Types.ScopeMode } }
      > }> | null | undefined } };

export type SubscribeToSequenceSheetMutationVariables = Types.Exact<{
  developmentId: Types.Scalars['ID']['input'];
  internalUserId: Types.Scalars['ID']['input'];
  follow: Types.Scalars['Boolean']['input'];
}>;


export type SubscribeToSequenceSheetMutation = { __typename?: 'Mutation', followSequenceSheet: { __typename?: 'FollowSequenceSheetResult', developments: Array<{ __typename?: 'Development', id: string, isSequenceSheetFollower: boolean, isTeamMember: boolean }>, internalUsers: Array<{ __typename?: 'InternalUser', id: string }> } };

export type SequenceSheetFollowerDetailsFragment = { __typename?: 'Development', id: string, isSequenceSheetFollower: boolean, isTeamMember: boolean };

export const SequenceSheetFollowerDetailsFragmentDoc = gql`
    fragment SequenceSheetFollowerDetails on Development {
  id
  isSequenceSheetFollower(internalUserId: $internalUserId)
  isTeamMember(internalUserId: $internalUserId)
}
    `;
export const LotSummaryMetaDataDocument = gql`
    query LotSummaryMetaData($developmentId: ID!, $internalUserId: ID!) {
  development(id: $developmentId) {
    ...SequenceSheetFollowerDetails
    name
    market {
      id
    }
    cohorts {
      id
      projects {
        id
        scopeMode {
          code
        }
      }
    }
  }
}
    ${SequenceSheetFollowerDetailsFragmentDoc}`;

/**
 * __useLotSummaryMetaDataQuery__
 *
 * To run a query within a React component, call `useLotSummaryMetaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotSummaryMetaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotSummaryMetaDataQuery({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *      internalUserId: // value for 'internalUserId'
 *   },
 * });
 */
export function useLotSummaryMetaDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables> & ({ variables: LotSummaryMetaDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables>(LotSummaryMetaDataDocument, options);
      }
export function useLotSummaryMetaDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables>(LotSummaryMetaDataDocument, options);
        }
// @ts-ignore
export function useLotSummaryMetaDataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables>;
export function useLotSummaryMetaDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LotSummaryMetaDataQuery | undefined, LotSummaryMetaDataQueryVariables>;
export function useLotSummaryMetaDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables>(LotSummaryMetaDataDocument, options);
        }
export type LotSummaryMetaDataQueryHookResult = ReturnType<typeof useLotSummaryMetaDataQuery>;
export type LotSummaryMetaDataLazyQueryHookResult = ReturnType<typeof useLotSummaryMetaDataLazyQuery>;
export type LotSummaryMetaDataSuspenseQueryHookResult = ReturnType<typeof useLotSummaryMetaDataSuspenseQuery>;
export type LotSummaryMetaDataQueryResult = Apollo.QueryResult<LotSummaryMetaDataQuery, LotSummaryMetaDataQueryVariables>;
export const SubscribeToSequenceSheetDocument = gql`
    mutation SubscribeToSequenceSheet($developmentId: ID!, $internalUserId: ID!, $follow: Boolean!) {
  followSequenceSheet(
    input: {developmentIds: [$developmentId], internalUserIds: [$internalUserId], follow: $follow}
  ) {
    developments {
      ...SequenceSheetFollowerDetails
    }
    internalUsers {
      id
    }
  }
}
    ${SequenceSheetFollowerDetailsFragmentDoc}`;
export type SubscribeToSequenceSheetMutationFn = Apollo.MutationFunction<SubscribeToSequenceSheetMutation, SubscribeToSequenceSheetMutationVariables>;

/**
 * __useSubscribeToSequenceSheetMutation__
 *
 * To run a mutation, you first call `useSubscribeToSequenceSheetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToSequenceSheetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [subscribeToSequenceSheetMutation, { data, loading, error }] = useSubscribeToSequenceSheetMutation({
 *   variables: {
 *      developmentId: // value for 'developmentId'
 *      internalUserId: // value for 'internalUserId'
 *      follow: // value for 'follow'
 *   },
 * });
 */
export function useSubscribeToSequenceSheetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SubscribeToSequenceSheetMutation, SubscribeToSequenceSheetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SubscribeToSequenceSheetMutation, SubscribeToSequenceSheetMutationVariables>(SubscribeToSequenceSheetDocument, options);
      }
export type SubscribeToSequenceSheetMutationHookResult = ReturnType<typeof useSubscribeToSequenceSheetMutation>;
export type SubscribeToSequenceSheetMutationResult = Apollo.MutationResult<SubscribeToSequenceSheetMutation>;
export type SubscribeToSequenceSheetMutationOptions = Apollo.BaseMutationOptions<SubscribeToSequenceSheetMutation, SubscribeToSequenceSheetMutationVariables>;